import React from "react";
import Preloader from "../helper/Preloader";
import { Link, useNavigate } from "react-router-dom";

import HeaderTwo from "../components/HeaderTwo";
import FooterTwo from "../components/FooterTwo";
import BottomFooter from "../components/BottomFooter";
import ScrollToTop from "react-scroll-to-top";
import ColorInit from "../helper/ColorInit";
import TextInput from "../components/TextInput";

import * as Yup from "yup";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { handleError } from "../utils/functions";
import SubmitButton from "../components/SubmitButton";
import axiosInstance from "../config/axios.config";
import { useDispatch } from "react-redux";
import { setAuth } from "../store/slice/auth";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import { GoogleLogin, GoogleOAuthProvider } from "@react-oauth/google";
import { jwtDecode } from "jwt-decode";

const schema = Yup.object().shape({
  email: Yup.string().email("Invalid email format").required("Email is required"),
  password: Yup.string().required("Password is Required"),
});

const AccountPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const {
    handleSubmit,
    register,
    setValue,
    formState: { isSubmitting, errors },
  } = useForm({ resolver: yupResolver(schema), mode: "all" });

  const onSubmit = async (data) => {
    try {
      const { data: res } = await axiosInstance.post("/user/login", data);
      if (!res.error) {
        if (!res.verified) {
          navigate(`/user-verify?token=${res.token}`);
        } else {
          dispatch(setAuth({ user: {}, token: res.token, userType: 1 }));
          navigate("/");
        }
      } else {
        toast.error(res.message);
      }
    } catch (error) {
      handleError(error);
    }
  };

  const loginWithGoogle = async (credential) => {
    try {
      const body = {
        email: credential.email,
        name: credential.name,
        profile: credential.picture,
      };
      const { data } = await axiosInstance.post("/user/google", body);
      if (!data.error) {
        dispatch(setAuth({ user: {}, token: data.token, userType: 1 }));
        navigate("/");
      } else {
        toast.error(data.error);
      }
    } catch (error) {
      handleError(error);
    }
  };

  return (
    <>
      {/* ColorInit */}
      <ColorInit color={true} />

      {/* ScrollToTop */}
      <ScrollToTop smooth color="#FA6400" />

      {/* Preloader */}
      <Preloader />

      {/* HeaderTwo */}
      <HeaderTwo category={true} />

      <section className="account py-80">
        <div className="container">
            <div className="row justify-content-around align-items-center">
              <div className="col-md-5">
                <img src="/assets/images/userL.png" className="w-100 rounded-11" alt={t("loginImage")} />
              </div>
              <div className="col-md-4">
                <div className="card">
                  <form onSubmit={handleSubmit(onSubmit)} className="card-body py-30 px-30">
                    <h3 className="my-30 text-center">{t("userLogin")}</h3>
                    <div className="mb-24">
                      <TextInput
                        name={"email"}
                        placeholder={t("enterEmail")}
                        isRequired
                        label={t("email")}
                        type={"email"}
                        register={register}
                        onChange={(e) => setValue("email", e.target.value)}
                        error={errors.email}
                      />
                    </div>
                    <div className="mb-24">
                      <TextInput
                        name={"password"}
                        placeholder={t("enterPassword")}
                        isRequired
                        label={t("password.password")}
                        type={"password"}
                        hasicon
                        register={register}
                        error={errors.password}
                        onChange={(e) => setValue("password", e.target.value)}
                      />
                      <p className="text-end">
                        <Link to="/find-account" className="text-main-600 text-decoration-underline">
                          {t("forgotPassword")}
                        </Link>
                      </p>
                    </div>

                    <div className="mt-30 text-center">
                      <SubmitButton className="w-100" isSubmitting={isSubmitting}>{t("login")}</SubmitButton>
                      <p className="mt-20">
                        {t("noAccount")}{" "}
                        <Link to="/user-register" className="text-main-600 text-decoration-underline">
                          {t("register")}
                        </Link>
                      </p>
                    </div>
                  </form>
                  <div className="d-flex mb-20 justify-content-center">
                    <GoogleOAuthProvider clientId="667919689139-spqe0qhtll4cbir08g085qd28as794oc.apps.googleusercontent.com">
                      <GoogleLogin
                        onSuccess={(credentialResponse) => {
                          if (credentialResponse.credential != null) {
                            const USER_CREDENTIAL = jwtDecode(credentialResponse.credential);
                            loginWithGoogle(USER_CREDENTIAL);
                          }
                        }}
                        onError={(error) => {
                          console.error(error);
                        }}
                        shape="circle"
                        theme="outline"
                        width="100%"
                        type="standard"
                        text="Google Login"
                        logo_alignment="center"
                      />
                    </GoogleOAuthProvider>
                  </div>
                </div>
              </div>
            </div>
          
        </div>
      </section>

      {/* FooterTwo */}
      <FooterTwo />

      {/* BottomFooter */}
      <BottomFooter />
    </>
  );
};

export default AccountPage;
